import api from '@/core/api';

export const searchProduct = async (search: string, appReference: string, countryCode: string) => {
    const trimSearch = search.trim();
    if (trimSearch.length < 1) {
        return null;
    }

    return await api.drafter.search(trimSearch, appReference, countryCode.toLowerCase());
}
